import axios from "axios";
import qs from "qs";
import BASEURL from "../../config";
import Url from "./urls";
import SSOList from "./basicConfig";
import i18n from "../i18nNext";
import { isMobile } from "@techsoftware/happay-widgets/CommonFunction/commonFunction";
import Common from "../constants/common";

// For storing reference of Api.js (So no need to use .call(this, ...))
var Api;
const init = api => {
    Api = api;
};

const handleSuccess = (response, target, multipleApiCall) => {
    const { data, headers = {} } = response;
    const gmailAddonInfo = sessionStorage.getItem("gmail-addon-info");
    // Here as we support gmail addon in the same domain,we dont update cid,token while calling login of gmail addon page
    if (headers["happay-cid"] && !gmailAddonInfo) {
        Api._setKey("cid", headers["happay-cid"]);
    }
    if (headers["happay-token"] && !gmailAddonInfo) {
        Api._setKey("token", headers["happay-token"]);
    }
    if (multipleApiCall) {
        return { status: "fullfilled", result: data };
    }
    target("success", data, headers);
};

const handleError = (error, target, multipleApiCall) => {
    const { status, statusText, data, config } = error;
    if (status === 401) {
        if (config.url.includes(Url.LOGIN)) {
            // // FOR HDFC Poweredby Login Error
            // if (Common._checkIfHdfcUrl() && data?.res_str === "You have entered invalid username or password." ) {
            //     Api._redirectToLogin(SSOList.isSSO());
            // }
        } else if (!localStorage.getItem("happay.cid") || !localStorage.getItem("happay.token")) {
            return false;
        } 
        else {
            Api._clearStorage();
            Api._redirectToLogin(SSOList.isSSO());
            return false;
        }
    }
    if (multipleApiCall) {
        return { status: "rejected", reason: error };
    } 
    let dt = {
        status: status,
        responseJSON: data || statusText || null
    };
    target("error", dt);
    
};

const callAxios = (options, target, multipleApiCall) => {
    return axios(options)
        .then(response => {
            return handleSuccess(response, target, multipleApiCall);
        })
        .catch(err => {
            const { response = { status: 0, statusText: err.message }, config } = err;
            // eslint-disable-next-line no-console
            console.log("err", err);
            if (response.status === 401 &&
                Boolean(Api._getKey("delegator_cid")) !== Boolean(config?.headers?.["happay-delegator"])
            ) {
                /**
                 * HEPIT-12434: Need to check 401 for cases where
                 * request header is matching with localstorage value of delegation
                 *
                 * Root Cause:
                 * Some requests are stalled in the netwrok and when the user is 
                 * switched to delegated view or vice versa that time the stalled request goes to the server
                 * Server sends 401 as it is not expected. So we log the user out.
                 */
                return false;
            }
            return handleError(response, target, multipleApiCall);
        });
};

const createOptions = (url, apiMethod, query, target, cType) => {
    const userAgent = navigator?.userAgent?.includes("request_from_nativemobile");
    let headers = {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json",
        "HAPPAY-DEVICE": userAgent ? "native" : isMobile ? "mobile" : "desktop"
    };

    if (Api._getKey("cid") && Api._getKey("token")) {
        headers["happay-cid"] = Api._getKey("cid");
        headers["happay-token"] = Api._getKey("token");
        headers["accept-language"] = i18n.language || "en-IN";

        if (Api._getKey("viewType") === "Privileged") {
            headers["happay-hasrole"] = "Y";
        } else {
            headers["happay-hasrole"] = "N";
            headers["x-csrftoken"] = Math.random();
        }
        if (Api._getKey("delegation_bit") === "true") {
            headers["happay-delegator"] = Api._getKey("delegator_cid");
            headers["happay-delegation-id"] = Api._getKey("delegation_id");
        }
    }

    const options = {
        method: apiMethod.toUpperCase(),
        url: `${BASEURL}${url}`, // Api URL
        headers: headers
    };

    switch (apiMethod.toLowerCase()) {
        case "get": {
            options.params = query;
            break;
        }
        case "post":
        case "put": {
            if (cType) {
                options.headers["Content-Type"] = cType;
                options.data = query;
            } else {
                options.data = qs.stringify(query);
                options.headers["Content-Type"] = "application/x-www-form-urlencoded";
            }
            break;
        }
        case "delete": {
            options.data = qs.stringify(query);
            options.headers["Content-Type"] = "application/x-www-form-urlencoded";
            break;
        }
        default:
            options.data = query;
    }

    return options;
};

function _callAPI(url, method, data = {}, target, cType, multipleApiCall) {
    data = data || {};

    // Storing context of Api file.
    init(this);

    const preLoginUser = [Url.PRELOGIN_CREATE_SUPER_USER, Url.PRELOGIN_CREATE_USER];
    const preLoginCheck = [
        Url.SSO_CHECK,
        Url.PRELOGIN_FETCH,
        Url.LOGIN,
        Url.PRELOGIN_SEND_OTP,
        Url.PRELOGIN_VERIFY_OTP,
        Url.PRELOGIN_VERIFY_EMAIL,
        Url.COUNTRYCODE_TYPEAHEAD,
        Url.VERIFY_EMAIL_ID,
        Url.GET_RBL_SBM_MIGRATION_OTP,
        Url.RESEND_RBL_SBM_MIGRATION_OTP,
        Url.VERIFY_RBL_SBM_MIGRATION_OTP,
        Url.RBL_SBM_MIGRATE_CARD_INIT_PIN,
        Url.RBL_SBM_MIGRATE_CARD_SET_PIN
    ];

    if (data.org_id && preLoginUser.includes(url)) {
        data.org_id = Api._getKey("org_id") || data.org_id ;
    } else if (!preLoginCheck.includes(url)) {
        if (!Api._getKey("cid") || !Api._getKey("token")) {
            return true;
        }
    }

    const options = createOptions(url, method, data, target, cType);

    return callAxios(options, target, multipleApiCall);
}

function _callMultipleApi(api, urls = [], method, data, target, cType) {
    Promise.all(
        urls.map((url) =>
            _callAPI.call(api, url, method, data, target, cType, "multipleApiCall")
        )
    ).then(response => {
        target("success", response);
    });
}

function _callApiWithoutBaseURL(url, method, query = {}, target, cType) {
    let headers = {
        Accept: "application/json",
        "Content-Type": "application/json"
    };
    const options = {
        method: method.toUpperCase(),
        url: url,
        headers: headers
    };

    switch (method.toLowerCase()) {
        case "get": {
            options.params = query;
            break;
        }
        case "post":
        case "put": {
            if (cType) {
                options.headers["Content-Type"] = cType;
                options.data = query;
            } else {
                options.data = qs.stringify(query);
                options.headers["Content-Type"] = "application/x-www-form-urlencoded";
            }
            break;
        }
        case "delete": {
            options.data = qs.stringify(query);
            options.headers["Content-Type"] = "application/x-www-form-urlencoded";
            break;
        }
        default:
            options.data = query;
    }

    return axios(options)
        .then(response => {
            return handleSuccess(response, target, false);
        })
        .catch(err => {
            // eslint-disable-next-line no-console
            console.log("err", err);
            const { response = { status: 0, statusText: err.message } } = err;
            return handleError(response, target, false);
        });
}

export { _callAPI, _callMultipleApi, _callApiWithoutBaseURL };
